import { v4 as uuid } from "uuid";
import { formatDate, parseISO } from "date-fns";

import { HttpPayload } from "frontend/interfaces/http";
import {
  Schedule,
  ScheduleNew,
  ScheduleRaw,
} from "frontend/interfaces/schedule";
import { DateFormat } from "shared/utils/date-utils";

export function parseSchedule(schedule: ScheduleRaw): Schedule {
  return {
    ...schedule,
    schedule_activations: schedule.schedule_activations.map((activation) => ({
      ...activation,
      from: activation.from ? parseISO(activation.from) : null,
      to: activation.to ? parseISO(activation.to) : null,
    })),
  };
}

export function httpPayloadSchedule(schedule: Schedule): HttpPayload {
  return {
    ...schedule,
    schedule_activations: schedule.schedule_activations.map((activation) => ({
      ...activation,
      from: activation.from
        ? formatDate(activation.from, DateFormat.ISO)
        : null,
      to: activation.to ? formatDate(activation.to, DateFormat.ISO) : null,
    })),
  };
}

export function newSchedule(): ScheduleNew {
  return {
    id: `MOCK-${uuid()}`,
    name: "",
    description: "",
    archived: false,
    unsaved: true,
    schedule_activations: [],
  };
}
